import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';


const styles = css`
  background-color: #F7F7F5;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  .container {
    max-width: 1400px;
  }
  .WelcomeText_info {
    display: block;
    text-align: center;
    position: relative;
    padding: 40px 20px;
    text-align: left;
    width:100%;
    z-index: 3;
    @media (min-width: 992px) {
      padding:90px 60px;
      text-align: center;
    }
  }
  .WelcomeText_pretitle {
    display: block;
    font-weight: 400;
    font-style: italic;
    color: ${colors.color2};
    font-family:${typography.Serif};
    font-size: 20px;
    letter-spacing: 4;
    text-align: center;
    line-height: 1;
    @media (min-width: 560px) {
      font-size: 22px;
    }
    @media (min-width: 768px) {
      font-size: 26px;
    }
    @media (min-width: 992px) {
      font-size: 30px;
    }

  }
  .WelcomeText_Title {
    display: block;
    font-weight: 200;
    font-style: normal;
    font-family:${typography.SansSerif} !important;
    font-size: 35px;
    letter-spacing: 2px;
    text-align: center;
    margin-top: 10px;
    line-height: 1.2;
    color: ${colors.color1};
    text-transform: uppercase;
    @media (min-width: 560px) {
      font-size: 30px;
    }
    @media (min-width: 768px) {
      font-size: 40px;
      letter-spacing: 4px;
    }
    @media (min-width: 992px) {
      font-size: 60px;
    }

  }
  .WelcomeText_copy {
    font-weight: 200;
    font-size: 20px;
    color: ${colors.body};
    letter-spacing: 0;
    line-height: 24px;
    padding: 0;
    margin-top: 30px;
    line-height: 25px;
    text-align: center;
    p {
      text-align: center;
        font-size: 22px;
        letter-spacing: 0;
        line-height: 1.4;
        @media (min-width: 992px) {
          font-size: 24px;
        }
    }
  }

  .btn {
    background-image: linear-gradient(213deg, #9F8B54 0%, rgba(183,168,121,0.99) 52%, rgba(109,94,52,0.99) 100%);
    display: block;
    margin: 15px 0 0 0;
    max-width: 2570px;
    color: ${colors.color1};
    @media (min-width: 992px) {
      margin: 20px auto;
      width: auto;
    }
  }
`;


function WelcomeText({ section }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="WelcomeText_info">
          <h1 className="WelcomeText_pretitle">{get(section, 'pretitle')}
            <span className="WelcomeText_Title">{get(section, 'title')}</span>
          </h1>
          <p className="WelcomeText_copy" dangerouslySetInnerHTML={SanitizeHtml(get(section, 'copy'))} />
        </div>
      </div>
    </div>
  );
}

WelcomeText.propTypes = {
  section: PropTypes.object.isRequired,
};

export default WelcomeText;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/WelcomeText.js